<script>
	import Rechner from './Rechner.svelte';
	import updateDocumentHeight from './iframeSizer';

	window.addEventListener('resize',updateDocumentHeight);
	window.addEventListener('load',updateDocumentHeight);

</script>

<main id="size-container" class="default-colors">
	<Rechner forderung={"10.000"} rendite={7} />
</main>

